/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedServiceTimeDropdown200,
  GetApiV1PersonSharedServiceTimeDropdown401,
  GetApiV1PersonSharedServiceTimeDropdown500,
  GetApiV1PersonSharedServiceTimeDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedServiceTimeDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedServiceTimeDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedServiceTimeDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedServiceTimeDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedServiceTimeDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedServiceTimeDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedServiceTimeDropdown500>;

export const getApiV1PersonSharedServiceTimeDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedServiceTimeDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedServiceTimeDropdownQueryResponse>;
